module.exports = {
    menu: {
        home: 'Home',
        team: 'Team',
        contact:'Contact'
    },
    team:[ 
        {post:'SAN Founder (Principal Partner)',name:'Yan Yu',introduce:'13 years’ experience in computer graphic industry. Mr. Yu regards SAN as his child, saying that the growth of this company is the same process as his child, it needs time and efforts to build for a successful future.',pic:'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg'},
        {post:'ccc',name:'dd',introduce:'xxxxxxxxxx',pic:'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg'},
        {post:'eee',name:'ff',introduce:'tttttttttt',pic:'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg'}
    ],
    contact: {
        company: 'CMK',
        phone: 'Phone',
        address: 'Address',
        guide: 'Guide',
        guideDetail:[
            {guide:'1.xxxxx'},
            {guide:'2.aaaaa'}
        ]
    }
}


// WEBPACK FOOTER //
// ./src/i18n/en.js